module.exports = __webpack_public_path__ + "media/images/webpage/hotels/model_cases/group_adult-c27f040288e3c5092b885a257f1ef5a5.webp";